import styled from 'styled-components';

export const Container = styled.div<{ isMobile?: boolean }>`
  width: ${(props) => (props.isMobile ? '100%' : 'fit-content')};
  display: flex;
  align-items: center;
  padding: 18px 16px;
  background: #f7f4ff;
  border-radius: 4px;
  border: 1px solid #1a055d;
  gap: 8px;

  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #1a055d;

    span {
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
      color: #1a055d;
    }
  }
`;
